<template>
  <div class="promoters-page">
    <div class="list">
      <div class="table-header">
        <div class="column-1">客户</div>
        <div class="column-2">
          状态
          <i
            class="fa fa-question-circle-o"
            @click="dialogShowStatespec = true"
          ></i>
        </div>
        <div class="column-3">维系时间</div>
      </div>
      <ul class="table-body">
        <li class="item" v-for="item in promotersList" :key="item.nickname">
          <div class="column-1" :title="item.message">
            {{ item.name }}
          </div>
          <div class="column-2">
            <div class="icon" :class="item.status"></div>
          </div>
          <div class="column-3" :title="item.room">
            {{ timeFormat(item.remain) }}
          </div>
        </li>
        <div class="no-data" v-if="!promotersList.length">暂无数据</div>
      </ul>
    </div>
    <el-dialog
      class="statespec-dialog"
      top="20%"
      :width="'70%'"
      :visible.sync="dialogShowStatespec"
      :modal-append-to-body="false"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-title">状态说明</div>
      <div class="dialog-body">
        <div class="item">
          <i class="icon on"></i>
          <p>
            正常状态：30天内有访问过你的分享 链接。TA的续费会自动计入你的推广
            分成，无需通过推广链接成交。
          </p>
        </div>
        <div class="item">
          <i class="icon off"></i>
          <p>
            灭灯状态：30天内没有访问过你的分 享链接。TA的续费不再计入你的推广
            分成。连续60天没访问你的推广链接 将会脱离你的推广关系，之后的续费
            不再计入你的推广分成。但是通过你 的分享链接成交的，依然计入你的推
            广分成。
          </p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogShowStatespec = false"
          >我知道了</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAgentUserList } from "@/api/index";
import { amountData } from "@/mixins/amountData";
export default {
  mixins: [amountData],
  data() {
    return {
      promotersList: [],
      dialogShowStatespec: false,
    };
  },
  mounted() {
    this.getAgentUserList();
  },
  methods: {
    getAgentUserList() {
      getAgentUserList().then((res) => {
        if (res.code == 0) {
          this.promotersList = res.data.list;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.promoters-page {
  height: 100%;
  .list {
    height: 100%;
    overflow: hidden;
    color: #101010;
    font-size: 14px;
    .table-header {
      height: 40px;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      font-size: 14px;
      color: #949cc4;
      border-bottom: 1px solid #e4e6f2;
      margin: 0 20px;
    }
    .table-body {
      height: calc(~"100% - 40px");
      overflow: auto;
      padding: 0 20px;
      margin: 0;
      padding-bottom: 70px;
      .item {
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        height: 14px;
        line-height: 14px;
        font-size: 14px;
        color: #3c3f5f;
        font-weight: 500;
        margin-top: 15px;
      }
    }
    .column-1 {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .column-2 {
      flex: 1;
      text-align: center;
    }
    .column-3 {
      flex: 1;
      text-align: right;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .icon {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    &.off {
      background: #737373;
    }
    &.on {
      background: #3ccc51;
    }
  }
  .no-data {
    font-size: 16px;
    text-align: center;
    color: #9f9f9f;
  }
  .statespec-dialog {
    .dialog-title {
      font-size: 20px;
      line-height: 28px;
      color: #101010;
      text-align: center;
    }
    .dialog-body {
      .item {
        display: flex;
        .icon {
          display: block;
          min-width: 14px;
          margin-right: 7px;
          margin-top: 4px;
        }
        p {
          font-size: 14px;
          color: #101010;
        }
      }
    }
    .dialog-footer {
      text-align: center;
    }
  }
}
</style>

<style lang="less">
.statespec-dialog {
  .el-dialog__header {
    padding: 17px 0 13px;
  }
  .el-dialog__body {
    padding: 0 20px;
  }
}
</style>
